import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { VALIDATORS } from 'app/constants';

@Component({
  selector: 'app-form-errors',
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.scss']
})
export class FormErrorsComponent {
  @Input() control!: AbstractControl | null;

  VALIDATORS = VALIDATORS;

  constructor() { }
}
